import React, { useEffect, useState } from "react";
import DialogComponent from "./dialogo";

export function AgreeLocations({
  isOpen,
  fromRenovarPage,
  validarClienteDentroColombia,
  toggleStateModalUserOutColombia,
  onOpenChange,
}) {
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };

  const handleClose = () => {
    setOpen(false);
    if (onOpenChange) onOpenChange(false);
  };

  const success = (pos) => {
    const crd = pos.coords;

    if (crd?.latitude && crd?.longitude) {
      localStorage.setItem(
        "coords",
        JSON.stringify({ lat: crd.latitude, lon: crd.longitude })
      );

      if (fromRenovarPage) {
        validarClienteDentroColombia({
          lat: crd.latitude,
          lon: crd.longitude,
        })
          .then((hasInColombia) => {
            toggleStateModalUserOutColombia(hasInColombia === false);
          })
          .catch((e) => console.log(e))
          .finally(() => {
            setLoading(false);
            handleClose();
          });
      } else {
        setLoading(false);
        handleClose();
      }
    } else {
      fallbackCoords();
    }
  };

  const error = (err) => {
    console.warn(`ERROR(${err.code}): ${err.message}`);
    fallbackCoords();
  };

  const fallbackCoords = () => {
    localStorage.setItem(
      "coords",
      JSON.stringify({ lat: "4.661695", lon: "-74.070759" })
    );
    setLoading(false);
    handleClose();
  };

  const askedPermissionLocate = () => {
    setLoading(true);
    navigator.geolocation.getCurrentPosition(success, error, options);
  };

  return (
    <DialogComponent
      open={open}
      onOpenChange={setOpen}
      title="¡Este paso es obligatorio!"
      description="Para seguir adelante con el proceso es importante aceptar la activación de geolocalización, con esto ayudas a proteger la seguridad de tu identidad."
      showAcceptButton={true}
      showCancelButton={false}
      acceptText="Acepto"
      onAccept={askedPermissionLocate}
      isLoadingAccept={loading}
      disableAccept={loading}
      isDesktop={true}
      disableBackdropClose={true}
      showCloseButton={false}
    />
  );
}
